import React from "react";

const stroke = (color, width = 2) => ({
  fill: "none",
  stroke: color,
  strokeWidth: width,
  strokeLinecap: "round",
  strokeLinejoin: "round",
});

export const IconClock = ({ color = "#FFFF00", size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke(color)} aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

export const IconCalendar = ({ color = "#FFFF00", size = 18, width = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke(color, width)} aria-hidden="true">
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </svg>
);

export const IconMail = ({ color = "#FFFF00", size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke(color)} aria-hidden="true">
    <path d="M4 6h16v12H4z" />
    <path d="M4 7l8 6 8-6" />
  </svg>
);

export const IconSheet = ({ color = "#FFFF00", size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke(color)} aria-hidden="true">
    <rect x="5" y="3" width="14" height="18" rx="2" />
    <path d="M9 8h6M9 12h6M9 16h4" />
  </svg>
);

export const IconStopwatch = ({ color = "#FFFF00", size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke(color)} aria-hidden="true">
    <circle cx="12" cy="13" r="8" />
    <path d="M12 9v4M9 2h6" />
  </svg>
);

export const IconStar = ({ color = "#FFFF00", size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke(color)} aria-hidden="true">
    <path d="M12 2l3 6 6 1-4.5 4.3 1 6.2L12 16.8 6.5 19.5l1-6.2L3 9l6-1z" />
  </svg>
);

export const IconCheck = ({ color = "currentColor", size = 18, width = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke(color, width)} aria-hidden="true">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

export const IconLock = () => (
  <svg width="11" height="12" viewBox="0 0 24 26" {...stroke("currentColor", 2.6)} aria-hidden="true">
    <rect x="4" y="11" width="16" height="13" rx="2.5" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);

export const IconBroadcast = () => (
  <svg width="16" height="12" viewBox="0 0 32 24" fill="none" strokeLinecap="round" aria-hidden="true">
    <circle cx="16" cy="12" r="4" fill="#FF5227" />
    <path d="M9 5a10 10 0 0 0 0 14M23 5a10 10 0 0 1 0 14" stroke="#FF5227" strokeWidth="2.6" />
    <path d="M4 1a16 16 0 0 0 0 22M28 1a16 16 0 0 1 0 22" stroke="#FF5227" strokeOpacity="0.5" strokeWidth="2.6" />
  </svg>
);

export const IconYoutube = () => (
  <svg width="20" height="14" viewBox="0 0 20 14" aria-hidden="true">
    <rect width="20" height="14" rx="4" fill="#FF5227" />
    <path d="M8 4v6l5-3z" fill="#FFFFFF" />
  </svg>
);

export const IconBlackCheck = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" style={{ flex: "none", marginTop: 2 }} aria-hidden="true">
    <path d="M3 10.5 7.6 15 17 4.5" stroke="#FF5227" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
